import { render, staticRenderFns } from "./inspePlans.vue?vue&type=template&id=c86e2824&scoped=true"
import script from "./inspePlans.vue?vue&type=script&lang=js"
export * from "./inspePlans.vue?vue&type=script&lang=js"
import style0 from "./inspePlans.vue?vue&type=style&index=0&id=c86e2824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86e2824",
  null
  
)

export default component.exports